import { isMobileDevice } from "../utility/utils";
class tdForm {
  constructor(formEl) {
    this.block = formEl;
    this.setFormEl();

    // Init the form on initial render and ajax reinitialization
    jQuery(document).on('gform_post_render', (event, form_id, current_page) => {
      if(this.formID == form_id){
        setTimeout(() => {
          this.init();
        }, 1);
      }
    });
  }

  init() {
    this.setFormEl();
    this.fields = this.getFieldData();
    this.submit = this.block.querySelector('button[type="submit"]');
    this.setUI();
    this.handleInputActiveState();
  }

  setFormEl() {
    this.form = this.block.querySelector("form");
    this.formID = this.form.getAttribute("data-formid");
  }

  getFieldData(fields = false) {
    fields = fields ? fields : this.block.querySelectorAll(".gfield:not(.gsection, .gfield--type-section, .gfield--type-html, .gfield_html");
    let fieldsData = [];
    fields.forEach((field) => {
      let fieldData = {};

      fieldData.wrapper = field;

      fieldData.input = field.querySelector(
        ".ginput_container textarea, .ginput_container input, .ginput_container select, textarea, input, select"
      );

      fieldData.label = field.querySelector(".gfield_label, .gform-field-label");
      
      fieldData.labelString = fieldData.label ? fieldData.label.innerText : "";
      if(fieldData.labelString.includes('*')){
        fieldData.labelString = fieldData.labelString.replace('*', '<span class="required">*</span>');  
      }

      if (fieldData.wrapper && fieldData.wrapper.classList.contains("gfield--type-html")) {
        fieldData.type = "html";
      } else if (fieldData.input && fieldData.input.classList.contains("datepicker")) {
        fieldData.type = "date";
      } else if (fieldData.input && fieldData.input.tagName === "TEXTAREA") {
        fieldData.type = "textarea";
      } else if (fieldData.input && fieldData.input.tagName === "SELECT") {
        fieldData.type = "select";
      } else {
        fieldData.type = "text";
      }

      fieldsData.push(fieldData);
    });

    return fieldsData;
  }

  setUI() {
    this.fields.forEach((field) => {
      if (field.wrapper && field.wrapper.classList.contains("gfield--type-address")) {
        const addressFields = this.getFieldData(field.wrapper.querySelectorAll('.ginput_complex > span'));

        addressFields.forEach((addressField) => {
          let addressUiMarkup = null;

          if (addressField.type && addressField.type === "select") {
            addressUiMarkup = this.selectUI(addressField);
          }

          if (addressUiMarkup && addressField.wrapper) {
            addressField.wrapper.appendChild(addressUiMarkup);
          }
        });

        return;
      }

      let uiMarkup = null;

      // Select Inputs
      if(field.type && field.type === "select") {
        uiMarkup = this.selectUI(field);
      }

      if(uiMarkup && field.wrapper){
        field.wrapper.appendChild(uiMarkup);
      }
    }); 
  }

  selectUI(field) {
    if (!field.input || field.input.dataset.tdSelectUiInitialized === 'true') return;

    const selectOptions = field.input ? field.input.querySelectorAll('option') : null;

    if(!selectOptions) return;

    // Select Wrapper
    const wrapper = document.createElement("div");
    wrapper.classList.add("td_form_ui");
    wrapper.classList.add("td_select_ui");

    // Select Trigger
    const trigger = document.createElement("div");
    trigger.classList.add('td_select_ui__trigger');
    trigger.setAttribute('tabindex', '0');

    // Select Trigger Text Span El
    const triggerText = document.createElement("span");
    triggerText.classList.add('td_select_ui__trigger_text');
    triggerText.innerHTML = field.labelString;
    trigger.appendChild(triggerText);

    // Select Trigger Icon
    const triggerIcon = document.createElement("span");
    triggerIcon.classList.add('td_select_ui__trigger_icon');
    triggerIcon.setAttribute('aria-hidden', 'true');
    trigger.appendChild(triggerIcon);

    // Select Options
    const options = document.createElement("ul");
    options.classList.add('td_select_ui__options');
    const optionsID = 'td_select__options_' + Math.floor(Math.random() * 1000000);
    options.setAttribute('id', optionsID);

    // Select Option
    selectOptions.forEach((option) => {
      if(!option.innerHTML) return;
      const optionEl = document.createElement("li");
      optionEl.classList.add('td_select_ui__option');

      const optionButton = document.createElement("div");
      optionButton.classList.add('td_select_ui__option_button');
      optionButton.innerHTML = option.innerHTML;
      optionButton.setAttribute('data-value', option.value);
      optionButton.setAttribute('tabindex', '0');

      optionEl.appendChild(optionButton);
      options.appendChild(optionEl);
    });

    const optionButtons = [...options.querySelectorAll('.td_select_ui__option_button')];
    let highlightedOption = null;
    let typeaheadTerm = '';
    let typeaheadTimeout = null;

    // Accessibility
    options.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-controls', optionsID);
    field.label.classList.add('td_select_ui__label');
    field.label.classList.add('hidden');

    // Put it together
    wrapper.appendChild(trigger);
    wrapper.appendChild(options);

    // Check if on load there is a selected option
    const selectedOption = field.input.querySelector('option[selected]') ? field.input.querySelector('option[selected]').innerHTML : null;
    if(selectedOption){
      triggerText.innerHTML = selectedOption;
      field.label.classList.remove('hidden');
    }

    const clearHighlightedOption = () => {
      if (highlightedOption) {
        highlightedOption.classList.remove('is-highlighted');
      }
      highlightedOption = null;
    };

    const resetTypeahead = () => {
      typeaheadTerm = '';

      if (typeaheadTimeout) {
        clearTimeout(typeaheadTimeout);
        typeaheadTimeout = null;
      }
    };

    const setHighlightedOption = (optionButton, shouldFocus = false) => {
      if (!optionButton) return;

      clearHighlightedOption();
      highlightedOption = optionButton;
      highlightedOption.classList.add('is-highlighted');

      if (shouldFocus) {
        highlightedOption.focus();
      }
    };

    const getSelectedOptionButton = () => {
      const selectedValue = field.input.value;
      return optionButtons.find((optionButton) => optionButton.getAttribute('data-value') === selectedValue);
    };

    const syncFromNativeSelect = () => {
      const selectedOption = field.input.options[field.input.selectedIndex];
      const selectedOptionButton = getSelectedOptionButton();

      if (selectedOption && selectedOption.text) {
        triggerText.innerHTML = selectedOption.text;
      } else {
        triggerText.innerHTML = field.labelString;
      }

      if (field.input.value && field.label.classList.contains('hidden')) {
        field.label.classList.remove('hidden');
      }

      if (!field.input.value && !field.label.classList.contains('hidden')) {
        field.label.classList.add('hidden');
      }

      if (wrapper.classList.contains('active')) {
        setHighlightedOption(selectedOptionButton || optionButtons[0]);
      }
    };

    const highlightOptionByOffset = (direction) => {
      const currentIndex = highlightedOption ? optionButtons.indexOf(highlightedOption) : optionButtons.indexOf(getSelectedOptionButton());

      if (!optionButtons.length) return;

      const nextIndex = currentIndex >= 0
        ? (currentIndex + direction + optionButtons.length) % optionButtons.length
        : 0;

      setHighlightedOption(optionButtons[nextIndex], true);
    };

    const highlightOptionBySearchTerm = (character) => {
      typeaheadTerm += character.toLowerCase();

      if (typeaheadTimeout) {
        clearTimeout(typeaheadTimeout);
      }

      typeaheadTimeout = setTimeout(() => {
        resetTypeahead();
      }, 500);

      const matchingOption = optionButtons.find((optionButton) => {
        const optionLabel = optionButton.textContent ? optionButton.textContent.trim().toLowerCase() : '';
        return optionLabel.startsWith(typeaheadTerm);
      });

      if (matchingOption) {
        setHighlightedOption(matchingOption, true);
        return;
      }

      resetTypeahead();
    };

    // Toggle Event
    const toggleSelect = () => {
      if(isMobileDevice()){
        field.input.classList.add('mobile_active');
        field.input.style.display = 'block';
        field.input.focus();

        // Listen for change event to update custom UI after selection
        field.input.addEventListener('change', function() {
          const selectedOption = field.input.options[field.input.selectedIndex].text;
          triggerText.innerHTML = selectedOption;
          field.input.style.display = 'none'; // Hide native select again
        });
      }
      else {
        wrapper.classList.toggle("active");
        options.setAttribute('aria-hidden', wrapper.classList.contains('active') ? 'false' : 'true');
        options.classList.toggle("active");
        trigger.classList.toggle("active");

        if (wrapper.classList.contains('active')) {
          resetTypeahead();
          setHighlightedOption(getSelectedOptionButton() || optionButtons[0]);
        } else {
          resetTypeahead();
          clearHighlightedOption();
        }
      }
    }

    // Close Event
    const closeOptions = () => {
      wrapper.classList.remove("active");
      options.classList.remove("active");
      options.setAttribute('aria-hidden', 'true');
      trigger.classList.remove("active");
      resetTypeahead();
      clearHighlightedOption();
    }

    // Selection Event
    const selectOption = (option, field) => {
      if(option.classList.contains('td_select_ui__option_button')) {
        const value = option.getAttribute('data-value');
        field.input.value = value;
        setHighlightedOption(option);

        if(field.label.classList.contains('hidden')){
          field.label.classList.remove('hidden');
        }

        field.input.dispatchEvent(new Event('change', { bubbles: true }));
        syncFromNativeSelect();
        
        closeOptions();
      }
    }

    // Toggle Select on Trigger Click
    trigger.addEventListener("click", () => {
      toggleSelect();
    });

    // Toggle Select when user clicks the enter key on the trigger
    trigger.addEventListener("keydown", (e) => {
      if(e.key === 'Enter') {
        e.preventDefault();
        toggleSelect();
        return;
      }

      if (!wrapper.classList.contains('active')) {
        if (e.key === ' ') {
          e.preventDefault();
          toggleSelect();
        }
        return;
      }

      if (e.key === ' ') {
        e.preventDefault();
        selectOption(highlightedOption || getSelectedOptionButton() || optionButtons[0], field);
        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlightOptionByOffset(1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlightOptionByOffset(-1);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeOptions();
      } else if (e.key.length === 1 && /[a-z0-9]/i.test(e.key)) {
        e.preventDefault();
        highlightOptionBySearchTerm(e.key);
      } else if (e.key === 'Tab') {
        closeOptions();
      }
    });

    // Close the options if clicked outside of the select
    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        closeOptions();
      }
    });

    // Set the field.input value to the selected option and close the options
    options.addEventListener("click", (e) => {
      selectOption(e.target, field);
    });

    // Set the field.input value on selected option with the enter key
    options.addEventListener("keydown", (e) => {
      if(e.key === 'Enter'){
        e.preventDefault();
        selectOption(e.target, field);
      } else if (e.key === ' ') {
        e.preventDefault();
        selectOption(highlightedOption || e.target, field);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlightOptionByOffset(1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlightOptionByOffset(-1);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeOptions();
        trigger.focus();
      } else if (e.key.length === 1 && /[a-z0-9]/i.test(e.key)) {
        e.preventDefault();
        highlightOptionBySearchTerm(e.key);
      }
    });

    options.addEventListener('mouseover', (e) => {
      if (e.target.classList.contains('td_select_ui__option_button')) {
        setHighlightedOption(e.target);
      }
    });

    options.addEventListener('focusin', (e) => {
      if (e.target.classList.contains('td_select_ui__option_button')) {
        setHighlightedOption(e.target);
      }
    });

    field.input.addEventListener('change', syncFromNativeSelect);
    field.input.addEventListener('input', syncFromNativeSelect);

    field.input.classList.add('td_select_ui__native_select');
    syncFromNativeSelect();

    // Watch for focus change. If focus is not in the select and it's open, close it
    document.addEventListener('focus', function(event) {
      if (!wrapper.contains(event.target) && wrapper.classList.contains('active')) {
        closeOptions();
      }
    }, true);

    field.input.dataset.tdSelectUiInitialized = 'true';

    return wrapper;
  }

  handleInputActiveState() {
    this.fields.forEach((field, index) => {
      if (field.wrapper && field.wrapper.classList.contains("gfield--type-address")) {
        const addressFields = this.getFieldData(field.wrapper.querySelectorAll('.ginput_complex > span'));

        addressFields.forEach((addressField) => {
          if (!addressField.initialized) {
            addressField.initialized = true;

            this.checkSelectPlaceholderPresence(addressField);
            this.prepPlaceholderAttr(addressField);
            this.setInputActiveState(addressField);

            if (addressField.input) {
              addressField.input.addEventListener("focus", () => {
                addressField.input.classList.add("focus");
                this.setInputActiveState(addressField);
                this.setPlaceholderState(addressField);
              });

              addressField.input.addEventListener("change", () => {
                this.setInputActiveState(addressField);
                this.setPlaceholderState(addressField);
              });

              addressField.input.addEventListener("focusout", () => {
                addressField.input.classList.remove("focus");
                this.setInputActiveState(addressField);
                this.setPlaceholderState(addressField);
              });
            }
          }
        });

        return;
      }

      if (!field.initialized) {
        field.initialized = true;

        this.checkSelectPlaceholderPresence(field);

        this.prepPlaceholderAttr(field);

        this.setInputActiveState(field); // run on load

        if (field.input) {
          field.input.addEventListener("focus", () => {
            field.input.classList.add("focus");
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
          field.input.addEventListener("change", () => {
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
          field.input.addEventListener("focusout", () => {
            field.input.classList.remove("focus");
            this.setInputActiveState(field);
            this.setPlaceholderState(field);
          });
        }
      }
    });
  }

  setInputActiveState(field) {
    if (!field || !field.input || !field.wrapper) return;

    const isFocused = field.input.classList.contains("focus");

    if (isFocused || field.input.value) {
      field.wrapper.classList.add("input_initiated");
    } else {
      field.wrapper.classList.remove("input_initiated");
    }

    // Select Field Specific
    // Check if selected option is a placeholder option and equal to the label
    if (field.type == "select") {
      const placeholderOption = field.input.querySelector("option.gf_placeholder");
      if (placeholderOption && !field.input.value) {
        if (placeholderOption.innerHTML == field.label.innerText) {
          field.wrapper.classList.add("hide_label");
        }
      } else if (field.wrapper.classList.contains("hide_label")) {
        field.wrapper.classList.remove("hide_label");
      }
    }
  }

  setPlaceholderState(field) {
    if (!field || !field.input) return;

    const placeholder = field.input.getAttribute("data-placeholder");

    if (placeholder) {
      const isFocused = field.input.classList.contains("focus");

      if (isFocused && !field.input.value) {
        field.input.setAttribute("placeholder", placeholder);
      } else {
        field.input.setAttribute("placeholder", "");
      }
    }
  }

  prepPlaceholderAttr(field) {
    if (!field || !field.input) return;

    const placeholder = field.input.getAttribute("placeholder");

    if (placeholder) {
      field.input.classList.add("has_placeholder");
      field.input.setAttribute("data-placeholder", placeholder);
      field.input.removeAttribute("placeholder");
    }
  }

  checkSelectPlaceholderPresence(field) {
    if (!field || !field.input) return;

    if (field.type == "select") {
      const placeholderOption = field.input.querySelector("option.gf_placeholder");

      if (!placeholderOption) {
        field.wrapper.classList.add("force_input_initiated");
      }
    }
  }
}

const InitForm = () => {
  const forms = document.querySelectorAll(".gform_wrapper");
  if (forms) {
    forms.forEach((formEl) => {
      formEl.formButtons = new tdForm(formEl);
    });
  }
};

export { InitForm };
